import {WixSdk} from '@wix/js-sdk-wrapper';
import {createParam} from '@wix/music-shared/dist/src/utils/url';
import {getBaseUrl} from '../../utils/env/base-url';
import {openModal} from '../../utils/wix-sdk';
import {TRACK_PAGE_DIMENSIONS} from '../constants';
import {disableInEditor} from './featureDisabledPopup';

export const showModal = (type: string) =>
  disableInEditor((data: Record<string, string>) => {
    let modalPath = `${getBaseUrl()}modals.html#/${type}`;
    if (data) {
      modalPath += `?${createParam(data)}`;
    }
    const activeElement = document.activeElement as HTMLElement;
    openModal(
      modalPath,
      TRACK_PAGE_DIMENSIONS.WIDTH,
      TRACK_PAGE_DIMENSIONS.HEIGHT,
      () => {
        activeElement.focus();
      },
      WixSdk.Theme.BARE,
    );
  });
